export default __webpack_public_path__ + "static/media/step-to-use.c23b6452.png";